import { SIDEBAR_TOGGLE } from './reduxConstant';
import { createReducer } from '../../utilities/reducerUtils';

const initialState = {
  isShrunk: false,
};

const sidebarToggle = (state, payload) => {
  return { isShrunk: payload.isShrunk };
};

export default createReducer(initialState, {
  [SIDEBAR_TOGGLE]: sidebarToggle,
});
